import { ReactElement } from 'react';
import Link from './Link';
import type { BreadcrumbItem } from 'lib/cms/breadcrumbs';

interface BreadcrumbNavProps {
  items: BreadcrumbItem[];
  /** Class name for the separator between items (default: 'text-gray-400') */
  separatorClassName?: string;
  /** Class name for clickable link items */
  linkClassName?: string;
  /** Class name for the current/last item (non-clickable) */
  currentClassName?: string;
}

export default function BreadcrumbNav({
  items,
  separatorClassName = 'text-gray-400',
  linkClassName = 'text-secondary-actual hover:text-gray-900',
  currentClassName = 'text-gray-900 font-medium',
}: BreadcrumbNavProps): ReactElement {
  return (
    <nav className="my-6 px-4 md:px-6" aria-label="Breadcrumb">
      <ol className="flex items-center gap-x-2 text-lg flex-wrap lg:flex-nowrap">
        {items.flatMap((item, index) => {
          const elements: ReactElement[] = [];
          if (index > 0) {
            elements.push(
              <li key={`sep-${index}`} className={separatorClassName}>
                {'>'}
              </li>
            );
          }
          elements.push(
            <li key={`${item.slug}-${item.label}-${index}`}>
              {item.slug && index < items.length - 1 ? (
                <Link slug={item.slug}>
                  <a className={linkClassName}>{item.label}</a>
                </Link>
              ) : (
                <span className={currentClassName}>{item.label}</span>
              )}
            </li>
          );
          return elements;
        })}
      </ol>
    </nav>
  );
}
